import { ExternalRequest } from 'src/app/shared/models/channel-communicator/external-request.model';
import { ExternalResponse } from 'src/app/shared/models/channel-communicator/external-response.model';

/**
 * Definición de la clase CyxteraService, Capa de seguridad a nivel del dispositivo
 *
 * *CyxteraService class definition, Security layer at device level*
 *
 * @type {class}
 */
export class CyxteraService {
  /**
   * Variable que registra el origen de abre cuentas
   *
   * *Variable to save abre centas origin*
   *
   * @type {private}
   * @var {string} ABRE_CUENTAS_ORIGIN
   */
  private ABRE_CUENTAS_ORIGIN: string;

  /**
   * Variable de función de promesa
   *
   * *function promises variable*
   *
   * @type {private}
   * @var {Function} postMessageToChannel
   */
  private createPromise: Function;

  /**
   * Declaración de función para promesas
   *
   * *Function promises declaration*
   *
   * @type {private}
   * @var {Function} createPromise
   */
  private postMessageToChannel: Function;

  /**
   * Función para comparar dos fechas
   *
   * *Function to compare two dates*
   *
   * @type {function}
   * @var {string} ABRE_CUENTAS_ORIGIN
   * @var {Function} createPromise
   * @var {Function} postMessageToChannel
   * @returns {number}
   */
  constructor(
        ABRE_CUENTAS_ORIGIN: string,
        createPromise: Function,
        postMessageToChannel: Function) {
    this.ABRE_CUENTAS_ORIGIN = ABRE_CUENTAS_ORIGIN;
    this.createPromise = createPromise;
    this.postMessageToChannel = postMessageToChannel;
  }

  /**
   * Función que inicializa la licencia Dsb
   *
   * *Init Dsb license*
   *
   * @type {Promise}
   * @param {string} license
   * @return {Promise}
   */
  initDsbLicense(license: string): Promise<ExternalResponse> {
    let promise: Promise<ExternalResponse>;

    const request: ExternalRequest = {
      origin: this.ABRE_CUENTAS_ORIGIN,
      op: 'DSBinitSDK',
      syncMode: true,
      payload: {
        licenseKey: license,
      },
    };

    promise = this.createPromise(request.op);

    this.postMessageToChannel(request);
    return promise;
  }

  /**
   * Función para validar la seguridad por medio de las reglas de riesgo
   *
   * *Function that validates security by risk rules*
   *
   * @type {Promise}
   * @return {Promise}
   */
  isSecureByRiskRules(): Promise<ExternalResponse> {
    let promise: Promise<ExternalResponse>;

    const request: ExternalRequest = {
      origin: this.ABRE_CUENTAS_ORIGIN,
      op: 'DSBisSecureByRiskRules',
      syncMode: true,
      payload: {},
    };

    promise = this.createPromise(request.op);

    this.postMessageToChannel(request);
    return promise;
  }

  /**
   * Función para validar la seguridad de los certificados
   *
   * *Function that validates certificates security*
   *
   * @type {Promise}
   * @return {Promise}
   */
  isSecureCertificate(secureUrl: string): Promise<ExternalResponse> {
    let promise: Promise<ExternalResponse>;

    const request: ExternalRequest = {
      origin: this.ABRE_CUENTAS_ORIGIN,
      op: 'DSBisSecureCertificate',
      syncMode: true,
      payload: {
        url: secureUrl,
      },
    };

    promise = this.createPromise(request.op);

    this.postMessageToChannel(request);
    return promise;
  }

  /**
   * Función para enviar la información a Dsb
   *
   * *Function to send data to Dsb*
   *
   * @type {Promise}
   * @param {string} userId
   * @return {Promise}
   */
  sendDataToDSB(userId: string): Promise<ExternalResponse> {
    let promise: Promise<ExternalResponse>;

    const request: ExternalRequest = {
      origin: this.ABRE_CUENTAS_ORIGIN,
      op: 'DSBsendLoginData',
      syncMode: false,
      payload: {
        user: userId,
      },
    };

    promise = this.createPromise(request.op);

    this.postMessageToChannel(request);
    return promise;
  }
}
